import axiosInstance from "../axiosInstance";
import { encryptRequestData } from '../../js/helper';

const apigeeDomain = process.env.REACT_APP_APIGEE_API_DM;

const channelOptions = {
    params: {
        channelId: "promoter",
    },
};

const getProductList = (merchantId) => {
    const requestOptions = { ...channelOptions };
    requestOptions.params.merchantId = merchantId;
    const URL = apigeeDomain + process.env.REACT_APP_APIGEE_PRODUCT_DETAILS;
    return axiosInstance.get(URL, requestOptions)
};

const getSegmentInfo = (selectedMerchant) => {
    const URL = apigeeDomain + process.env.REACT_APP_API_PROMOTOR_SEGMENT;
    const requestOptions = {
        params: {
            merchantId: selectedMerchant
        },
    }
    return axiosInstance.get(URL, requestOptions);
};

const sendQRGenerate = (details) => {
    const URL = apigeeDomain + process.env.REACT_APP_API_PRODUCT;

    const headers = {
        headers: encryptRequestData(details)
    };

    return axiosInstance.post(URL, details, headers);
};

const sendUserSMS = (requestData) => {
    const URL = apigeeDomain + process.env.REACT_APP_API_SEND_SMS;

    const headers = {
        headers: encryptRequestData(requestData)
    };

    return axiosInstance.post(URL, requestData, headers);
};

const getDashboard = (promoterId) => {
    const URL = apigeeDomain + process.env.REACT_APP_API_PROMOTER_DASHBOARD + `?userID=${promoterId}`;
    return axiosInstance.get(URL);
}

const getMerchantList = (promoterId) => {
    const requestOptions = {
        params: {
            userId: promoterId,
            action: "merchantList"
        },
    }
    const URL = apigeeDomain + process.env.REACT_APP_PROMOTOR_MERCHANT_API;
    return axiosInstance.get(URL, requestOptions);
}

const getMerchantDetail = (selectedMerchant) => {
    const requestOptions = {
        params: {
            merchantCode: selectedMerchant,
            action: "merchantDetail"
        },
    }
    const URL = apigeeDomain + process.env.REACT_APP_PROMOTOR_MERCHANT_API;
    return axiosInstance.get(URL, requestOptions);
}

const getVASDetail = (typeId, selectedMerchant) => {
    const requestOptions = { ...channelOptions };
    requestOptions.params.typeId = typeId;
    requestOptions.params.merchantId = selectedMerchant;
    const URL = apigeeDomain + process.env.REACT_APP_APIGEE_VAS_FEE_URL;
    return axiosInstance.get(URL, requestOptions);
}

const getRanking = (requestParams) => {
    const URL = apigeeDomain + process.env.REACT_APP_API_PROMOTER_RANKING;
    return axiosInstance.get(URL, requestParams);
}

export { getSegmentInfo, sendQRGenerate, getProductList, sendUserSMS, getDashboard, getMerchantList, getMerchantDetail, getVASDetail, getRanking };